<template>
  <div class="progress-bar" style="margin-bottom: 24px;">
    <div style="display: flex; align-items: center; justify-content: space-between; max-width: 200px; margin: 0 auto; position: relative;">
      <div v-for="step in totalSteps" :key="step" style="position: relative;">
        <div
          :class="{ 'step-active': step === currentStep }"
          :style="stepStyle(step)"
        >
          {{ step }}
        </div>
        <div
          v-if="step < totalSteps"
          :style="lineStyle(step)"
          style="position: absolute; top: 50%; transform: translateY(-50%); left: 100%; width: 35px; height: 1px;"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LpProgressBar',
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, default: 4 }
  },
  methods: {
    stepStyle (step) {
      var base = {
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '500',
        position: 'relative',
        zIndex: '10',
        transition: 'all 300ms'
      }
      if (step < this.currentStep) {
        base.backgroundColor = '#1877b2'
        base.border = '2px solid #1877b2'
        base.color = '#fff'
        return base
      }
      if (step === this.currentStep) {
        base.backgroundColor = '#fff'
        base.border = '2px solid #1877b2'
        base.color = '#1877b2'
        base.fontWeight = 'bold'
        return base
      }
      base.backgroundColor = '#fff'
      base.border = '1px solid #ddd'
      base.color = '#aaa'
      return base
    },
    lineStyle (step) {
      return { backgroundColor: step < this.currentStep ? '#1877b2' : '#ddd' }
    }
  }
}
</script>

<style>
@keyframes stepPulse {
  0% { box-shadow: 0 0 0 0 rgba(24, 119, 178, 0.4); }
  70% { box-shadow: 0 0 0 10px rgba(24, 119, 178, 0); }
  100% { box-shadow: 0 0 0 0 rgba(24, 119, 178, 0); }
}
.step-active {
  animation: stepPulse 2s infinite;
}
</style>
